import { useModal } from '../../useDialog';
import { getWalletModalProps } from '../../../config/walletModal';
import FinpspPaymentDialog from '../../../components/forms/finpsp/FinpspPaymentDialog';

export const useOpenFinpspPayment = () => {
  const { openModal, closeModal } = useModal();

  return (transactionId: string) => {
    openModal(
      <FinpspPaymentDialog transactionId={transactionId} onClose={closeModal} />,
      getWalletModalProps({ backgroundColor: 'neutral.700' })
    );
  };
};
